import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPage3.module.less'
import PdfPage from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage3(props: Props) {
  const { t } = useTranslation()
  const { onRendered } = props

  useEffect(() => {
    onRendered(1)
  }, [])

  return (
    <PdfPage no={props.no} bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-3/PDF-bg-3.jpg')}>
      <div className={styles.pdfPage3}>
        <img
          className={styles.cntTitle}
          src={commonUtils.getImagePath('PDFDownload/01.png')}
          alt=''
        />
        <img
          className={styles.circle}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-3/page3-icon.png')}
        />
        <div className={styles.desc}>{t('dashboard.projectDetailPage.basicInformation')}</div>
      </div>
    </PdfPage>
  )
}

export default PdfPage3
